<template>
  <div>
    <b-modal
      id="modal-atualizacao-cadastral"
      centered
      hide-footer
      scrollable
      title="Atualização do cadastro"
      v-model="modalUpdateUser"
      size="lg"
      hide-header-close
      no-close-on-backdrop
    >
      <ol class="list-unstyled stepper">
        <li
          v-for="(item, idx) in steps"
          :key="idx"
          :class="{
            'stepper--success': step > idx + 1,
            'stepper--current': step === idx + 1,
          }"
        >
          <span class="stepper__count">{{ idx + 1 }}</span>
          <div class="stepper__caption d-none d-md-block">
            {{ item.title }}
          </div>
        </li>
      </ol>
      <div v-show="step == 1">
        <div class="body">
          <termos-de-uso></termos-de-uso>
        </div>
        <hr />
        <div class="row">
          <ValidationObserver ref="observer" class="col-9">
            <validation-provider
              v-slot="{ errors }"
              :rules="{ required: { allowFalse: false } }"
            >
              <div class="error">{{ errors[0] }}</div>
              <div class="form-group input-group">
                <div class="checkbox">
                  <label
                    ><input
                      type="checkbox"
                      value=""
                      v-model="checkedTerms"
                      required
                    />
                    Li e estou de acordo com os Termos de uso.
                  </label>
                </div>
              </div>
            </validation-provider>
          </ValidationObserver>
          <div class="col-3 mt-2">
            <button type="submit" class="btn float-right" @click="nextStep()">
              Avançar <i class="icofont-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>
      <div v-show="step == 2">
        <ValidationObserver ref="form" class="row">
          <div class="col-md-6 col-12">
            <validation-provider v-slot="{ errors }" rules="required">
              <div class="error">{{ errors[0] }}</div>
              <div class="form-group input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="icofont-ui-user"></i>
                  </span>
                </div>
                <input
                  name="nome"
                  v-model="form.nome"
                  class="form-control"
                  placeholder="NOME COMPLETO"
                  type="text"
                />
              </div>
            </validation-provider>
          </div>
          <div class="col-md-6 col-12">
            <validation-provider v-slot="{ errors }" rules="">
              <div class="error">{{ errors[0] }}</div>
              <div class="form-group input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="icofont-ui-user"></i>
                  </span>
                </div>
                <input
                  name="data_nascimento"
                  v-model="form.data_nascimento"
                  class="form-control"
                  placeholder="DATA DE NASCIMENTO"
                  type="text"
                  onfocus="(this.type='date')"
                />
              </div>
            </validation-provider>
          </div>
          <div class="col-md-6 col-12">
            <validation-provider v-slot="{ errors }" rules="email">
              <div class="error">{{ errors[0] }}</div>
              <div class="form-group input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="icofont-envelope"></i>
                  </span>
                </div>
                <input
                  name="email"
                  v-model="form.email"
                  class="form-control"
                  placeholder="E-MAIL"
                  type="email"
                />
              </div>
            </validation-provider>
          </div>
          <div class="col-md-6 col-12">
            <validation-provider v-slot="{ errors }" rules="phone">
              <div class="error">{{ errors[0] }}</div>
              <div class="form-group input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="icofont-phone"></i>
                  </span>
                </div>
                <the-mask
                  :mask="['(##) ####-####', '(##) #####-####']"
                  v-model="form.telefone"
                  class="form-control"
                  placeholder="TELEFONE"
                />
              </div>
            </validation-provider>
          </div>
          <div class="col-md-6 col-12 mt-2">
            <validation-provider v-slot="{ errors }" rules="required|password">
              <!-- <div class="error">{{ errors[0] }}</div> -->
              <div class="form-group input-group">
                <div
                  class="input-group-prepend"
                  @click="showPassword = !showPassword"
                  style="cursor: pointer"
                >
                  <span class="input-group-text">
                    <i
                      :class="
                        showPassword ? 'icofont-eye-blocked' : 'icofont-eye'
                      "
                    ></i>
                  </span>
                </div>
                <input
                  name="senha"
                  v-model="form.senha"
                  class="form-control"
                  placeholder="SENHA"
                  :type="showPassword ? 'text' : 'password'"
                  required
                />
              </div>
              <div class="mt-2 mb-2">
                <ul>
                  <li :class="colorLenght">
                    <i :class="lenghtPassword"></i> 8 ou mais caracteres;
                  </li>
                  <li :class="colorLetters">
                    <i :class="lettersPassword"></i> 1 ou mais letras
                    maiúsculas;
                    <span
                      v-b-tooltip.hover
                      title="A B C D E F G H I J K L M N O P Q R S T U V W X Y Z"
                      class="icon-tooltip"
                    >
                      <i class="icofont-info-circle"></i>
                    </span>
                  </li>
                  <li :class="colorNumbers">
                    <i :class="numbersPassword"></i> 1 ou mais números;
                    <span
                      v-b-tooltip.hover
                      title="1 2 3 4 5 6 7 8 9 0"
                      class="icon-tooltip"
                    >
                      <i class="icofont-info-circle"></i>
                    </span>
                  </li>
                  <li :class="colorSpecialChars">
                    <i :class="SpecialCharsPassword"></i> 1 ou mais caracteres
                    especiais.
                    <span
                      v-b-tooltip.hover
                      title="Exemplos de caracteres especiais: ! @ # $ % ^ & * ( ) _ + \ - = [ \ ] { } ; : \ \ | , . < > / ? ~"
                      class="icon-tooltip"
                    >
                      <i class="icofont-info-circle"></i>
                    </span>
                  </li>
                </ul>
              </div>
            </validation-provider>
          </div>
          <div class="col-md-6 col-12 mt-2">
            <validation-provider v-slot="{ errors }" rules="required|password">
              <!-- <div class="error">{{ errors[0] }}</div> -->
              <div class="form-group input-group">
                <div
                  class="input-group-prepend"
                  @click="showConfirmedPassword = !showConfirmedPassword"
                  style="cursor: pointer"
                >
                  <span class="input-group-text">
                    <i
                      :class="
                        showConfirmedPassword
                          ? 'icofont-eye-blocked'
                          : 'icofont-eye'
                      "
                    ></i>
                  </span>
                </div>
                <input
                  name="senha"
                  v-model="form.confirmarsenha"
                  class="form-control"
                  placeholder="CONFIRMAR SENHA"
                  :type="showConfirmedPassword ? 'text' : 'password'"
                  required
                />
              </div>
            </validation-provider>
          </div>
          <div class="col-md-12">
            <div class="btn-actions">
              <button type="submit" class="btn" v-on:click="step = 1">
                <i class="icofont-arrow-left"></i> Voltar
              </button>
              <button
                type="submit"
                class="btn btn-submit"
                v-on:click="atualizarCadastro()"
              >
                Atualizar <i class="icofont-save"></i>
                <b-spinner
                  label="Spinning"
                  small
                  variant="white"
                  v-if="loading"
                ></b-spinner>
              </button>
            </div>
          </div>
        </ValidationObserver>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
import { TheMask } from 'vue-the-mask'
import TermosDeUso from '@/components/TermosDeUso.vue'
validations()

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    TheMask,
    TermosDeUso,
  },
  data() {
    return {
      modalUpdateUser: false,
      checkedTerms: false,
      steps: [{ title: 'Termos de Uso' }, { title: 'Atualizar senha' }],
      step: 1,
      form: {
        nome: '',
        data_nascimento: '',
        email: '',
        telefone: '',
        senha: '',
        confirmarsenha: '',
      },
      loading: false,
      showPassword: false,
      showConfirmedPassword: false,
    }
  },
  async created() {
    await this.verificaUltimaAtualizacaoDoCadastro()
  },
  computed: {
    colorLenght() {
      if (this.form.senha.length < 8) {
        return 'red'
      }
      return 'green'
    },
    lenghtPassword() {
      if (this.form.senha.length < 8) {
        return 'icofont-close'
      }
      return 'icofont-check'
    },
    colorNumbers() {
      if (/\d/.test(this.form.senha)) {
        return 'green'
      }
      return 'red'
    },
    numbersPassword() {
      if (/\d/.test(this.form.senha)) {
        return 'icofont-check'
      }
      return 'icofont-close'
    },
    colorLetters() {
      if (/[A-Z]/.test(this.form.senha)) {
        return 'green'
      }
      return 'red'
    },
    lettersPassword() {
      if (/[A-Z]/.test(this.form.senha)) {
        return 'icofont-check'
      }
      return 'icofont-close'
    },
    colorSpecialChars() {
      if (/[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(this.form.senha)) {
        return 'green'
      }
      return 'red'
    },
    SpecialCharsPassword() {
      if (/[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(this.form.senha)) {
        return 'icofont-check'
      }
      return 'icofont-close'
    },
  },
  methods: {
    /**
     * Prenche os campos do formulário com os dados do usuário
     */
    async verificaUltimaAtualizacaoDoCadastro() {
      try {
        if (this.$store.state.id != null && this.$store.state.id != '') {
          this.modalUpdateUser = true
          let user = await this.$api.get('/app/usuario/' + this.$store.state.id)
          this.form.nome = user.data.nome
          this.form.data_nascimento = user.data.data_nascimento
            .split('-')
            .reverse()
            .join('/')
          this.form.email = user.data.email
          this.form.telefone = user.data.telefone
        } else {
          this.$router.push('/login')
        }
      } catch (error) {
        console.log(error)
        this.$router.push('/login')
      }
    },

    /**
     * Avança para o próximo passo
     */
    async nextStep() {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        this.step++
      }
    },

    /**
     * Executa a atualização do cadastro
     */
    async atualizarCadastro() {
      const isValid = await this.$refs.form.validate()
      if (isValid) {
        if (this.checkedTerms) {
          if (this.form.senha == this.form.confirmarsenha) {
            this.loading = true
            const usuario = {
              nome: this.form.nome,
              email: this.form.email,
              telefone: this.form.telefone,
              data_nascimento: this.form.data_nascimento,
              senha: this.form.senha,
              id: this.$store.state.id,
            }
            this.$api
              .put('/app/usuario', usuario)
              .then((response) => {
                if (response.data.error == true) {
                  this.$toast.error(response.data.message, 'Error:', {
                    position: 'topRight',
                  })
                } else {
                  this.modalUpdateUser = false
                  this.$toast.success(response.data.message, 'Sucesso:', {
                    position: 'topRight',
                  })
                  this.$store.commit('setRequiredPasswordUpdate', false)
                  if (
                    this.$store.state.id_funcao == 4 ||
                    this.$store.state.id_funcao == 5 ||
                    this.$store.state.id_funcao == 8 ||
                    this.$store.state.id_funcao == 14 ||
                    this.$store.state.id_funcao == 15
                  ) {
                    this.$router.push('/login')
                  } else {
                    this.$router.push('/dashboard')
                  }
                }
              })
              .catch(function (error) {
                console.log(error)
                this.$toast.error(
                  'Por favor, entre em contato com o suporte.',
                  'Error:',
                  {
                    position: 'topRight',
                  }
                )
              })
              .finally(() => {
                this.loading = false
              })
          } else {
            this.$toast.error('As senhas não conferem!', 'Error:', {
              position: 'topRight',
            })
          }
        }
      }
    },
  },
}
</script>

<style lang="scss">
#modal-atualizacao-cadastral {
  .stepper {
    display: flex;
    justify-content: space-between;
    li {
      flex-basis: 100%;
      text-align: center;
      position: relative;
      &:not(:first-child):before {
        content: '';
        position: absolute;
        left: -50%;
        right: 50%;
        top: 1.125rem;
        border-top: 1px solid;
      }
      &.stepper--success {
        color: #0fafd7;
        .stepper__count {
          color: #fff;
          background-color: #0fafd7;
        }
      }
      &.stepper--current {
        color: #0fafd7;
      }
    }
    &__count {
      font-size: 1.125rem;
      display: inline-block;
      width: 2.25rem;
      height: 2.25rem;
      line-height: 2.25rem;
      border: 1px solid;
      border-radius: 50%;
      background: #fff;
      position: relative;
      z-index: 9;
      cursor: pointer;
    }
    &__caption {
      font-weight: 500;
      margin-top: 0.5rem;
      display: block;
    }
  }
  .body {
    height: 400px;
    overflow-y: scroll;
  }
  .btn-actions {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    button {
      width: 140px;
    }
  }
}
</style>
